function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "ico_menu_compass_background",
  "data-name": "ico/menu/compass background",
  width: 24,
  height: 24,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Combined_Shape",
  "data-name": "Combined Shape",
  d: "M0,10A10,10,0,1,1,10,20,10.011,10.011,0,0,1,0,10Zm1,0a9,9,0,1,0,9-9A9.01,9.01,0,0,0,1,10Zm4.761,4.238L7.88,7.88,14.24,5.76l-2.12,6.36L5.762,14.239h0Zm2.91-5.567L7.341,12.659l3.988-1.329,1.329-3.988Z",
  transform: "translate(2 2)",
  fill: "#bccad0"
});

var SvgBookings = function SvgBookings(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_menu_charts_copy_2",
    "data-name": "ico/menu/charts copy 2",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBookings, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bookings.c507c476.svg";
export { ForwardRef as ReactComponent };